// @generated by protoc-gen-es v2.15.0 with parameter "target=ts,import_extension=js"
// @generated from file console/admin/v1/android_auto.proto (package console.admin.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file console/admin/v1/android_auto.proto.
 */
export const file_console_admin_v1_android_auto: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_timestamp]);

/**
 * One certificate of `aa-server.crt`, as it reads. Public.
 *
 * @generated from message console.admin.v1.CertificateFacts
 */
export type CertificateFacts = Message<"console.admin.v1.CertificateFacts"> & {
  /**
   * Distinguished names as `CN=..., O=...`, in the certificate's own order.
   *
   * @generated from field: string subject = 1;
   */
  subject: string;

  /**
   * @generated from field: string issuer = 2;
   */
  issuer: string;

  /**
   * Hex, as `openssl x509 -serial` prints it.
   *
   * @generated from field: string serial = 3;
   */
  serial: string;

  /**
   * @generated from field: google.protobuf.Timestamp not_before = 4;
   */
  notBefore?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp not_after = 5;
   */
  notAfter?: Timestamp | undefined;

  /**
   * sha256 (hex) of the certificate's DER.
   *
   * @generated from field: string sha256 = 6;
   */
  sha256: string;
};

/**
 * Describes the message console.admin.v1.CertificateFacts.
 * Use `create(CertificateFactsSchema)` to create a new message.
 */
export const CertificateFactsSchema: GenMessage<CertificateFacts> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_android_auto, 0);

/**
 * @generated from message console.admin.v1.AndroidAutoCertificate
 */
export type AndroidAutoCertificate = Message<"console.admin.v1.AndroidAutoCertificate"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * The certificate devices present to a head unit: the first in
   * `aa-server.crt`, and the one `aa-server.key` belongs to. Its dates are
   * the pair's.
   *
   * @generated from field: console.admin.v1.CertificateFacts presented = 2;
   */
  presented?: CertificateFacts | undefined;

  /**
   * The certificates after it in `aa-server.crt`, each the issuer of the one
   * before it. Empty for a certificate that stands alone.
   *
   * @generated from field: repeated console.admin.v1.CertificateFacts issuers = 3;
   */
  issuers: CertificateFacts[];

  /**
   * What `aa-server.key` is, e.g. `RSA 2048` or `EC P-256`. Never the key.
   *
   * @generated from field: string key_algorithm = 4;
   */
  keyAlgorithm: string;

  /**
   * sha256 (hex) of `aa-server.crt` as devices receive it, which is what a
   * device reports it has.
   *
   * @generated from field: string cert_sha256 = 5;
   */
  certSha256: string;

  /**
   * @generated from field: string uploaded_by_name = 6;
   */
  uploadedByName: string;

  /**
   * @generated from field: google.protobuf.Timestamp uploaded_at = 7;
   */
  uploadedAt?: Timestamp | undefined;

  /**
   * `current` or `retired`.
   *
   * @generated from field: string state = 8;
   */
  state: string;

  /**
   * @generated from field: google.protobuf.Timestamp retired_at = 9;
   */
  retiredAt?: Timestamp | undefined;
};

/**
 * Describes the message console.admin.v1.AndroidAutoCertificate.
 * Use `create(AndroidAutoCertificateSchema)` to create a new message.
 */
export const AndroidAutoCertificateSchema: GenMessage<AndroidAutoCertificate> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_android_auto, 1);

/**
 * @generated from message console.admin.v1.GetAndroidAutoCertificateRequest
 */
export type GetAndroidAutoCertificateRequest = Message<"console.admin.v1.GetAndroidAutoCertificateRequest"> & {
};

/**
 * Describes the message console.admin.v1.GetAndroidAutoCertificateRequest.
 * Use `create(GetAndroidAutoCertificateRequestSchema)` to create a new message.
 */
export const GetAndroidAutoCertificateRequestSchema: GenMessage<GetAndroidAutoCertificateRequest> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_android_auto, 2);

/**
 * @generated from message console.admin.v1.GetAndroidAutoCertificateResponse
 */
export type GetAndroidAutoCertificateResponse = Message<"console.admin.v1.GetAndroidAutoCertificateResponse"> & {
  /**
   * The pair devices are offered. Absent until one is uploaded; devices then
   * present the certificate they were deployed with.
   *
   * @generated from field: console.admin.v1.AndroidAutoCertificate current = 1;
   */
  current?: AndroidAutoCertificate | undefined;

  /**
   * Earlier pairs, newest first. Their certificates only: a retired pair has
   * no key.
   *
   * @generated from field: repeated console.admin.v1.AndroidAutoCertificate retired = 2;
   */
  retired: AndroidAutoCertificate[];

  /**
   * Active, assigned devices, and how many of them said they have the
   * current certificate.
   *
   * @generated from field: uint32 devices_current = 3;
   */
  devicesCurrent: number;

  /**
   * @generated from field: uint32 devices_total = 4;
   */
  devicesTotal: number;
};

/**
 * Describes the message console.admin.v1.GetAndroidAutoCertificateResponse.
 * Use `create(GetAndroidAutoCertificateResponseSchema)` to create a new message.
 */
export const GetAndroidAutoCertificateResponseSchema: GenMessage<GetAndroidAutoCertificateResponse> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_android_auto, 3);

/**
 * @generated from message console.admin.v1.CheckAndroidAutoCertificateRequest
 */
export type CheckAndroidAutoCertificateRequest = Message<"console.admin.v1.CheckAndroidAutoCertificateRequest"> & {
  /**
   * `aa-server.crt` as pasted or dropped: PEM certificates, the one devices
   * present first, each followed by the one that issued it. Empty when it is
   * not given yet.
   *
   * @generated from field: string cert_pem = 1;
   */
  certPem: string;

  /**
   * `aa-server.key`: one unencrypted PKCS#8 PEM private key. Empty when it is
   * not given yet. Key material: never stored by Check, never logged.
   *
   * @generated from field: string key_pem = 2;
   */
  keyPem: string;
};

/**
 * Describes the message console.admin.v1.CheckAndroidAutoCertificateRequest.
 * Use `create(CheckAndroidAutoCertificateRequestSchema)` to create a new message.
 */
export const CheckAndroidAutoCertificateRequestSchema: GenMessage<CheckAndroidAutoCertificateRequest> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_android_auto, 4);

/**
 * @generated from message console.admin.v1.CheckAndroidAutoCertificateResponse
 */
export type CheckAndroidAutoCertificateResponse = Message<"console.admin.v1.CheckAndroidAutoCertificateResponse"> & {
  /**
   * What `cert_pem` reads as, as `AndroidAutoCertificate` has it. Absent, and
   * no issuers, while it does not read.
   *
   * @generated from field: console.admin.v1.CertificateFacts presented = 1;
   */
  presented?: CertificateFacts | undefined;

  /**
   * @generated from field: repeated console.admin.v1.CertificateFacts issuers = 2;
   */
  issuers: CertificateFacts[];

  /**
   * What the key is, e.g. `RSA 2048`. Empty when no key was given or it does
   * not read.
   *
   * @generated from field: string key_algorithm = 3;
   */
  keyAlgorithm: string;

  /**
   * Each a sentence naming what is wrong and how to fix it. Any of them
   * refuses the pair.
   *
   * @generated from field: repeated string cert_problems = 4;
   */
  certProblems: string[];

  /**
   * @generated from field: repeated string key_problems = 5;
   */
  keyProblems: string[];

  /**
   * Problems of the two together: the key does not belong to the certificate.
   *
   * @generated from field: repeated string pair_problems = 6;
   */
  pairProblems: string[];

  /**
   * Worth knowing and refusing nothing: the certificate expires within 15
   * days, or before the current one does.
   *
   * @generated from field: repeated string warnings = 7;
   */
  warnings: string[];

  /**
   * sha256 (hex) of `aa-server.crt` as devices would receive it. Empty while
   * the certificate does not read.
   *
   * @generated from field: string cert_sha256 = 8;
   */
  certSha256: string;
};

/**
 * Describes the message console.admin.v1.CheckAndroidAutoCertificateResponse.
 * Use `create(CheckAndroidAutoCertificateResponseSchema)` to create a new message.
 */
export const CheckAndroidAutoCertificateResponseSchema: GenMessage<CheckAndroidAutoCertificateResponse> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_android_auto, 5);

/**
 * @generated from message console.admin.v1.SetAndroidAutoCertificateRequest
 */
export type SetAndroidAutoCertificateRequest = Message<"console.admin.v1.SetAndroidAutoCertificateRequest"> & {
  /**
   * @generated from field: string cert_pem = 1;
   */
  certPem: string;

  /**
   * Key material. Wrapped for storage like an organization's key, and never
   * logged or answered.
   *
   * @generated from field: string key_pem = 2;
   */
  keyPem: string;

  /**
   * The id of the pair the caller saw as current, empty for none. When
   * another is current, nothing changes and the refusal says so, so a pair
   * is never replaced unseen.
   *
   * @generated from field: string replaces = 3;
   */
  replaces: string;
};

/**
 * Describes the message console.admin.v1.SetAndroidAutoCertificateRequest.
 * Use `create(SetAndroidAutoCertificateRequestSchema)` to create a new message.
 */
export const SetAndroidAutoCertificateRequestSchema: GenMessage<SetAndroidAutoCertificateRequest> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_android_auto, 6);

/**
 * @generated from message console.admin.v1.SetAndroidAutoCertificateResponse
 */
export type SetAndroidAutoCertificateResponse = Message<"console.admin.v1.SetAndroidAutoCertificateResponse"> & {
  /**
   * @generated from field: console.admin.v1.AndroidAutoCertificate current = 1;
   */
  current?: AndroidAutoCertificate | undefined;
};

/**
 * Describes the message console.admin.v1.SetAndroidAutoCertificateResponse.
 * Use `create(SetAndroidAutoCertificateResponseSchema)` to create a new message.
 */
export const SetAndroidAutoCertificateResponseSchema: GenMessage<SetAndroidAutoCertificateResponse> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_android_auto, 7);

/**
 * The Android Auto server certificate devices present to a head unit, as
 * MotionSafe staff see it: one pair, `aa-server.crt` and `aa-server.key`, for
 * every device. The leaf is short-lived and is re-cut from time to time;
 * SetAndroidAutoCertificate replaces the pair devices are offered, and each
 * device fetches it at its next heartbeat with an operator signed in
 * (DeviceService.GetAndroidAutoCertificate). Staff only. Every member of staff
 * may call Get; Check and Set are a MotionSafe admin's.
 *
 * @generated from service console.admin.v1.AndroidAutoService
 */
export const AndroidAutoService: GenService<{
  /**
   * @generated from rpc console.admin.v1.AndroidAutoService.GetAndroidAutoCertificate
   */
  getAndroidAutoCertificate: {
    methodKind: "unary";
    input: typeof GetAndroidAutoCertificateRequestSchema;
    output: typeof GetAndroidAutoCertificateResponseSchema;
  },
  /**
   * Reads a pair, or either half of one, and says what it is and what is
   * wrong with it. Stores nothing, and nothing of the key is answered or
   * logged. The page asks as each file is pasted or dropped.
   *
   * @generated from rpc console.admin.v1.AndroidAutoService.CheckAndroidAutoCertificate
   */
  checkAndroidAutoCertificate: {
    methodKind: "unary";
    input: typeof CheckAndroidAutoCertificateRequestSchema;
    output: typeof CheckAndroidAutoCertificateResponseSchema;
  },
  /**
   * Makes a pair current: the same checks as Check, refused when any fails.
   * The pair current before it is retired and its key discarded, in the same
   * step. Audited as `android_auto.certificate_set`.
   *
   * @generated from rpc console.admin.v1.AndroidAutoService.SetAndroidAutoCertificate
   */
  setAndroidAutoCertificate: {
    methodKind: "unary";
    input: typeof SetAndroidAutoCertificateRequestSchema;
    output: typeof SetAndroidAutoCertificateResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_console_admin_v1_android_auto, 0);

